var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.155 403.601c-43.565 0.395-56.901 16.984-56.901 37.934 0 20.952 15.113 37.935 56.901 37.935 41.79 0 56.905-16.984 56.905-37.935s-13.338-38.331-56.905-37.934z m227.614 0c-43.567 0.395-56.905 16.984-56.905 37.934 0 20.952 15.115 37.935 56.905 37.935 41.788 0 56.901-16.984 56.901-37.935 0.001-20.951-13.336-38.331-56.901-37.934z m142.256-253.55H383.511c-172.849 0-312.967 140.12-312.967 312.967 0 112.509 59.367 211.151 148.483 266.31 38.117 23.594 22.226 179.433 22.226 179.433s186.946-132.776 199.159-132.776h227.613c172.849 0 312.967-140.12 312.967-312.967S840.874 150.051 668.025 150.051z m0.387 585.628H433.059c-10.721 0-153.872 97.21-153.872 97.21s-6.404-118.311-40.405-138.034c-71.3-41.359-129.705-145.439-130.304-233.022-0.967-141.385 132.829-272.858 274.645-273.846h285.29c137.871 0 274.647 136.418 274.647 273.846-0.001 144.334-135.791 275.821-274.648 273.846z m84.968-332.078c-43.565 0.395-56.901 16.984-56.901 37.934 0 20.952 15.113 37.935 56.901 37.935 41.79 0 56.903-16.984 56.903-37.935s-13.336-38.331-56.903-37.934z",
    fill: "#5ca6ed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentBlue);
export default __webpack_public_path__ + "static/media/comment-blue.7273b511c13a127c3af78de5a9936e26.svg";
export { ForwardRef as ReactComponent };